var map = {
	"./": 72881,
	"./arrows": 77379,
	"./arrows.jsx": 77379,
	"./balloon": 79236,
	"./balloon.jsx": 79236,
	"./binoculars": 31267,
	"./binoculars.jsx": 31267,
	"./index": 72881,
	"./index.jsx": 72881,
	"./pen": 41208,
	"./pen.jsx": 41208,
	"./quote": 4081,
	"./quote.jsx": 4081,
	"./quotes": 83306,
	"./quotes.jsx": 83306,
	"./square": 54076,
	"./square.jsx": 54076,
	"./wedge": 65313,
	"./wedge.jsx": 65313
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23077;